import { render, staticRenderFns } from "./DetectionRequest.vue?vue&type=template&id=68e5ff1b&scoped=true"
import script from "./DetectionRequest.vue?vue&type=script&lang=js"
export * from "./DetectionRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5ff1b",
  null
  
)

export default component.exports